import { AnnouncementBanner } from "@alchemy/ui";
import { Network } from "@util/constants";
import { Loadable } from "@util/loadable";
import { OrderedIdMap, arrayFromOrderedIdMap } from "@util/orderedIdMap";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllAppQueryCounts } from "../../redux/appStats";
import { App, fetchApps } from "../../redux/apps";
import { AppDispatch, RootState } from "../../redux/root";

const getNumActiveOptimismGoerliApps = (
  apps: Loadable<OrderedIdMap<string, App>>,
  queryCounts24h: Loadable<{
    [appId: string]: number;
  }>,
) => {
  const appsList = Loadable.map(apps, arrayFromOrderedIdMap).value || [];
  const appsWithRequests = appsList.map((app) => ({
    ...app,
    requests24h: queryCounts24h.value?.[app.id] ?? 0,
  }));
  const activeOptimismGoerliApps = appsWithRequests.filter(
    (app) => app.network === Network.OPT_GOERLI && app.requests24h > 0,
  );

  return activeOptimismGoerliApps.length;
};

const OptimismGoerliDeprecationBanner = () => {
  const dispatch = useDispatch<AppDispatch>();
  const apps = useSelector((state: RootState) => state.apps.apps);
  const queryCounts24h = useSelector(
    (state: RootState) => state.appStats.queryCounts24h,
  );

  useEffect(() => {
    void dispatch(fetchApps());
    void dispatch(fetchAllAppQueryCounts());
  }, [dispatch]);

  const numActiveOptimismGoerliApps = getNumActiveOptimismGoerliApps(
    apps,
    queryCounts24h,
  );

  if (numActiveOptimismGoerliApps === 0) {
    return null;
  }

  return (
    <AnnouncementBanner intent="error">
      Optimism Goerli support will be ending March 7.{" "}
      <AnnouncementBanner.Link
        target="_blank"
        href="https://www.alchemy.com/blog/optimism-goerli-testnet-deprecation"
      >
        Please migrate to Sepolia.
      </AnnouncementBanner.Link>{" "}
    </AnnouncementBanner>
  );
};

export default OptimismGoerliDeprecationBanner;
